import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import { useCart } from './CartContext';
import './rice.css';

const products = [
  { name: 'Coconut Oil', image: '/images/oil/coconut.webp', link: '/oil/coconut' },
  { name: 'Sesame Oil', image: '/images/oil/sesame.webp', link: '/oil/sesame' },
  { name: 'Groundnut Oil', image: '/images/oil/groundnut.webp', link: '/oil/groundnut' },
  { name: 'Deepam Oil', image: '/images/oil/dheepam.webp', link: '/oil/deepam' },
  { name: 'Mustard Oil', image: '/images/oil/mustard.webp', link: '/oil/mustard' },
  { name: 'Sunflower Oil', image: '/images/oil/sunflower.webp', link: '/oil/sunflower' }
];

const qtyOptions = ['200ml', '500ml', '1ltr', '2ltr', '5ltr'];


const Oil = () => {
  const navigate = useNavigate();
  const { addToCart } = useCart();
  const [selectedQuantities, setSelectedQuantities] = useState({});

  const handleKnowMore = (link) => {
    navigate(link);
  };

  const goToProducts = () => {
    navigate('/products');
  };

  const toggleQtyType = (productIndex, qtyType) => {
    const productQuantities = selectedQuantities[productIndex] || {};
    const isSelected = qtyType in productQuantities;

    const updated = { ...productQuantities };
    if (isSelected) {
      delete updated[qtyType];
    } else {
      updated[qtyType] = 1;
    }

    setSelectedQuantities({
      ...selectedQuantities,
      [productIndex]: updated,
    });
  };

  const incrementQty = (index, qtyType) => {
    const productQuantities = selectedQuantities[index] || {};
    const currentQty = productQuantities[qtyType] || 1;

    setSelectedQuantities({
      ...selectedQuantities,
      [index]: {
        ...productQuantities,
        [qtyType]: currentQty + 1,
      },
    });
  };

  const decrementQty = (index, qtyType) => {
    const productQuantities = selectedQuantities[index] || {};
    const currentQty = productQuantities[qtyType];

    if (currentQty > 1) {
      setSelectedQuantities({
        ...selectedQuantities,
        [index]: {
          ...productQuantities,
          [qtyType]: currentQty - 1,
        },
      });
    }
  };

  const handleAddToCart = (product, index) => {
    const quantities = selectedQuantities[index];
    if (!quantities || Object.keys(quantities).length === 0) {
      toast.warn("Please select at least one quantity!", { position: "top-right" });
      return;
    }

    Object.entries(quantities).forEach(([qtyType, qtyCount]) => {
      const item = {
        ...product,
        qtyType,
        qtyCount,
      };
      addToCart(item);
      toast.success(`${product.name} (${qtyCount} × ${qtyType}) added to cart`, {
        position: "top-right",
        autoClose: 2000,
      });
    });
  };


  return (
    <section className="rice">
      <div className='border'>
        <img src="/images/border.png" className='border-img' alt="decorative border" />
      </div>
      <h1>Jeyam Oil Products</h1>
      <div className='border'>
        <img src="/images/border.png" className='border-img' alt="decorative border" />
      </div>
      <button className='back-btn' onClick={goToProducts}>⟵ Back to Products</button>

      <div className="product-grid">
        {products.map((product, index) => (
          <div className="product-card" key={index}>
            <img src={product.image} alt={product.name} />
            <div className="product-name">{product.name}</div>
            <div className="qty-options">
              {qtyOptions.map((qtyType) => {
                const isSelected = selectedQuantities[index]?.[qtyType];

                return (
                  <div key={qtyType} className="qty-select-block">
                    <span
                      className={isSelected ? 'qty selected' : 'qty'}
                      onClick={() => toggleQtyType(index, qtyType)}
                    >
                      {qtyType}
                    </span>
                    {isSelected && (
                      <div className="qty-controls">
                        <button onClick={() => decrementQty(index, qtyType)}>-</button>
                        <span>{selectedQuantities[index][qtyType]}</span>
                        <button onClick={() => incrementQty(index, qtyType)}>+</button>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>

            <div className="btn-group">
              <button className="know-more" onClick={() => handleKnowMore(product.link)}>
                Know More
              </button>
              <button className="add-cart" onClick={() => handleAddToCart(product, index)}>
                Add to Cart
              </button>
            </div>
          </div>
        ))}
      </div>

      <div className='cart-button'>
        <Link to="/cart">
          <button className='cart-btn'>Go To Cart</button>
        </Link>
      </div>
      <Link to="/cart" className="floating-cart-btn" title="Go to Cart">
        Go to cart 🛒
      </Link>

      <ToastContainer />
    </section>
  );
};

export default Oil;
